<mat-form-field appearance="outline" [subscriptSizing]="subscript_sizing">
	<mat-label>{{ label }}</mat-label>
	<input matInput [matDatepicker]="picker" [formControl]="control" [required]="is_required" (blur)="markTouched()">
	<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
	<mat-datepicker #picker (closed)="markTouched()"></mat-datepicker>
</mat-form-field>
